import { axiosClient } from '../axios';

export const handlePdfDownload = async (pdfUrl: string, pdfTitle: string) => {
  const fileName = `${pdfTitle}.pdf`;

  return handleFileDownload(pdfUrl, fileName);
};

export const handleFileDownload = async (fileUrl: string, fileName: string) => {
  const response = await axiosClient(fileUrl, {
    responseType: 'blob',
    isAuthorizationNeeded: false,
  });
  const url = window.URL.createObjectURL(new Blob([response.data as BlobPart]));
  const link = document.createElement('a');
  link.href = url;
  link.download = fileName;
  link.click();
  URL.revokeObjectURL(url);
};
